import { buildGlobalReferenceContext } from '../../../../context/buildGlobalReferenceContext.mjs';

const TEXT_AREA_NAME = "TextArea";
const [TextAreaProvider, useTextAreaContext] = buildGlobalReferenceContext(TEXT_AREA_NAME);

export { TextAreaProvider, useTextAreaContext };
//# sourceMappingURL=context.mjs.map
